

import { IconProps } from "@/models/Icon";

export function MethodIcon({ size = 14, color = "#5E5C5D"}: IconProps) {
    return(
        <svg width={size} height={size} viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.45032 6C1.45032 9.03757 3.91275 11.5 6.95032 11.5C9.98788 11.5 12.4503 9.03757 12.4503 6C12.4503 2.96243 9.98788 0.5 6.95032 0.5" stroke={color} stroke-linecap="round"/>
            <path d="M5.29504 0.755127C3.51883 1.31575 2.22751 2.69422 1.70507 4.34461" stroke={color} stroke-linecap="round"/>
        </svg>
    )
}